<template>
    <div>
        <h4>
            <input
                type="radio"
                :checked="selected"
                @click="$emit('selected')"
            >
            Mail a check
        </h4>
        <fieldset
            class="check"
            v-show="selected"
        >
            <div class="agree">
                I will mail a check *:
                <input
                    type="checkbox"
                    v-model="agreed"
                    :value="true"
                    style="margin-left: 10px;"
                >
            </div>
            <p>
                Mail a check to our business address:
            </p>
            <ul style="list-style: none; margin: 5px 20px; font-weight: 600;">
                <li>Derby Lane Cottage</li>
                <li>604 Crooked Road</li>
                <li>Bar Harbor, ME 04609</li>
            </ul>
            <p>
                We will hold your reservation for 10 days. If we don't receive a deposit in that time, we may
                open your stay dates up for other guests. You may return to this page to use a credit card if
                you change your mind.
            </p>
        </fieldset>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import MyInput from './form/MyInput';

export default {
    components: {
        MyInput,
    },

    mixins: [ validationMixin ],

    props: {
        selected: {
            type: Boolean,
        },
    },

    data() {
        return {
            agreed: false,
        };
    },

    watch: {
        agreed() {
            this.$emit('valid', this.agreed);
        },
    },

    methods: {
    },
}
</script>

<style>
.agree {
    font-size: 110%;
    font-weight: bold;
    margin: 0;
}
</style>
